<template>
  <div v-show="isActive" class="tabs-slot"><slot></slot></div>
</template>

<script>
export default {
  name: "Tab",
  provide(){
    return{
      isActive: () => this.isActive
    }
  },
  props: {
    name: { required: true },
    selected: { default: false}
  },
  data() {

    return {
      isActive: false
    }

  },

  mounted() {

    this.isActive = this.selected;

  }
}
</script>

<style scoped>

</style>
